//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'error404',
  data () {
    return {
    }
  },
  methods: {
    reload () {
      window.location.href = 'http://mng.5idream.net/api/index'
    }
  }
}




// WEBPACK FOOTER //
// ./src/components/errorPage/404.vue